import type { ThemeConfig } from 'antd';

// import { theme as AntdTheme } from 'antd';
import { colors } from '@/tailwind.config';
const theme: ThemeConfig = {
  // algorithm: [AntdTheme.darkAlgorithm],

  components: {
    Layout: {
      colorBgHeader: colors['surface_0'],
    },
    Button: {
      // primaryColor: colors['primary'],
      // colorPrimaryBg: colors['primary'],
    },
    Menu: {
      itemSelectedBg: colors['primary_A10'],
      itemBg: colors['surface_0'],
      itemActiveBg: colors['primary_A10'],
      itemColor: colors['default_80'],
      itemHeight: 36,
    },
    Input: {
      colorBgContainer: colors['surface_0'], // activeBg: colors['surface_0'],
      errorActiveShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
    },
    Select: {
      // v1.0
      optionFontSize: 15,

      controlItemBgActive: colors['primary_A10'],
      multipleItemBg: colors['primary_A10'],
      optionSelectedBg: colors['primary_A10'],
    },
    Radio: {},
    Message: {},
    Modal: {},
    Popconfirm: {},
    Slider: {},
    Upload: {},
    InputNumber: {
      colorBgContainer: '#43444A',
      paddingInline: 8,
      handleBorderColor: '#43444A',
      colorText: '#fff',
      handleBg: '#43444A',
      controlWidth: 85,
    },
  },

  token: {
    // Seed Token，影响范围大
    colorPrimary: '#4E4EE9',
    borderRadius: 8,
    // 派生变量，影响范围小
    colorBgBase: colors['surface_0'],
    colorTextBase: colors['default_80'],
    // colorBorder: '#B8B8B829',
    colorPrimaryBg: colors['primary'],
    // colorLink: '#FE4854',
    // colorSplit: '#53536B',
    colorError: '#DE014A',
    lineWidth: 0.5,
    opacityLoading: 0.5,
  },
};

export default theme;
